/* eslint-disable eqeqeq */
import {
  CmpSelectBox,
  CmpTextField,
  CmpButton,
  CmpTextFieldEnter,
  CmpDatePicker,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import { Box, Grid } from '@mui/material';
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button, TextField } from "@mui/material";
import { fExecuteAPI } from "../../Server/Apis";
import { useSelector } from "react-redux";
import { fcovertToNumber } from "../../Utility/Utilitys";
import EasyLoading_Breadcrumbs from "./EasyLoading_BreadCrumbs";
import { fAlertToast, GetGitterColumns } from "../../Utility/Utilitys";
import Modal from "@mui/material/Modal";
import { confirmAlert } from "react-confirm-alert"; // Import
// import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import {
  EasyLoadingHead_Status_Set,
  EasyLoadingSubHeader_Set,
  EasyLoadingSubHeader_Truck_Set,
} from "./SliceEasyLoading";
import useMediaQuery from "@mui/material/useMediaQuery";
import "./EasyLoading.css";
import {
  GetAttributes,
  GetEasyLoadingSubHead,
  WMS_PICKING_DROP_ID_Flag,
  fNewTrip_Create,
  fTruckid_dependency,
} from "./EasyLoadingAction";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import {
  EasyLoadingBarcode_GETROW,
  EasyLoadingDelete_GETROW,
  EasyLoadingPost_GETROW,
  EasyLoadingUpdate_GETROW,
  EasyLoadingVariance_GETROW,
  EasyLoading_GETROW,
} from "../../Server/ApiV2";
import EasyLoadingModal from "./component/EasyLoadingModal";
import { RoEasyLoading, RoEasyLoadingSubHead } from "../../Redux/roStore";
import { useNavigate } from "react-router-dom";
import DetailCardComp, {
  DetailInputDisplay,
} from "../../Component/Common/ReuseableComponent/DetailCardComp";

const columns = [
  {
    field: "G_SrNo",
    headerName: "Sr No",
    width: 50,
  },
  {
    field: "G_BinCd",
    headerName: "LoadingBay Code",
    width: 80,
    hide: true,
  },
  {
    field: "BinName",
    headerName: "LoadingBay",
    width: 150,
  },
  {
    field: "G_CardID",
    headerName: "Barcode Code",
    width: 130,
  },
  {
    field: "G_ItmCd",
    headerName: "Item Code",
    width: 100,
    hide: true,
  },
  {
    field: "ItmName",
    headerName: "Item Name",
    width: 250,
  },
  {
    field: "G_Qty",
    headerName: "Qty",
    width: 80,
  },
  {
    field: "G_Unit",
    headerName: "Unit Code",
    width: 50,
  },
  {
    field: "G_BaseQty",
    headerName: "BaseQty",
    width: 70,
  },
  {
    field: "G_NDX_ROWID",
    headerName: "G_NDX_ROWID",
    width: 50,
    hide: true,
  },
  {
    field: "G_RefDocTyp",
    headerName: "RefDocTyp",
    width: 100,
    hide: true,
  },
  {
    field: "G_RefDocNo",
    headerName: "RefDocNo",
    width: 100,
    hide: true,
  },
];

const VarianceColumns = [
  {
    field: "ItmCd",
    headerName: "Item Code",
    width: 90,
  },
  {
    field: "Name1",
    headerName: "Item Name",
    width: 400,
  },
  // {
  //     field: 'picked',
  //     headerName: 'Picked',
  //     width: 80,
  // },
  {
    field: "Qty",
    headerName: "Qty",
    width: 100,
  },
  {
    field: "PkdQty",
    headerName: "PkdQty",
    width: 100,
  },
];

export default function EasyLoadingDetail() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const EasyLoadingDetailFocusOnLoad = useRef(null);
  const vRdxDetail = useSelector(
    (state) => state.SliceEasyLoading.value.EasyLoadingHead
  );
  const vRdxSubHead = useSelector(
    (state) => state.SliceEasyLoading.value.EasyLoadingSubHeader
  );
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const [sGridRow, setGridRow] = useState([]);
  const [sGridVarienceRow, setGridVarienceRow] = useState([]);
  const [sUnitData, setUnitDataArr] = useState([]);
  const [sVersionData, setVersionData] = useState([]);
  const [sTruck, setTruck] = useState([]);
  const sEnterKeyObj = {
    key: "Enter",
  };
  const [sDetail, setDetail] = useState({
    SrNo: 0,
    ItemCode: "",
    ItemName: "",
    SuppRefNo1: "",
    BarCode: "",
    CardId: "",
    Qty: 0,
    DropID: "",
    Unit: "",
    PackQty: 0,
    BaseQty: 0,
    LoadQty: 0,
    LoadingQty: 0,
    BalanceQty: 0,
    IndexRowID: 0,
    RefDocTyp: "",
    RefDocNo: "All",
  });
  let vDetailObjInit = {
    SrNo: 0,
    ItemCode: "",
    ItemName: "",
    SuppRefNo1: 0,
    BarCode: "",
    CardId: "",
    Qty: 0,
    DropID: "",
    Unit: "",
    PackQty: 0,
    BaseQty: 0,
    LoadQty: 0,
    LoadingQty: 0,
    BalanceQty: 0,
    IndexRowID: 0,
    RefDocTyp: "",
    RefDocNo: "All",
  };
  const [sErrorMsg, setErrorMsg] = useState({
    SrNo: "",
    ItemCode: "",
    ItemName: "",
    BarCode: "",
    CardId: "",
    Qty: "",
    DropID: "",
    Unit: "",
    PackQty: "",
    BaseQty: "",
    LoadQty: "",
    LoadingQty: "",
    BalanceQty: "",
  });

  let vErrorInit = {
    SrNo: "",
    ItemCode: "",
    ItemName: "",
    BarCode: "",
    CardId: "",
    Qty: "",
    DropID: "",
    Unit: "",
    PackQty: "",
    BaseQty: "",
    LoadQty: "",
    LoadingQty: "",
    BalanceQty: "",
  };

  const [sOpenDetailViewModel, setOpenDetailViewModel] = useState(false);

  const fCloseDetailViewModel = () => {
    setOpenDetailViewModel(false);
  };

  const fOpenDetailViewModel = () => {
    setOpenDetailViewModel(true);
  };
  const [sOpenPostVarianceModel, setOpenVarianceModel] = useState(false);

  const fCloseVarianceModel = () => {
    setOpenVarianceModel(false);
    setGridVarienceRow([]);
  };

  const fOpenVarianceModel = () => {
    setOpenVarianceModel(true);
  };

  const fOnKeyUp = async (e) => {
    if (e.key === "Enter") {
      GetCartBarcodeDetail(sDetail.SrNo, sDetail.BarCode, false);
    } else if (e.key === "Backspace" || e.keyCode === 8) {
      setDetail((obj) => ({
        ...obj,
        ItemCode: "",
        ItemName: "",
        Unit: "",
        PackQty: 0,
        LoadQty: 0,
        LoadingQty: 0,
        BalanceQty: 0,
        SuppRefNo1: 0,
      }));
      fBaseQty(sDetail.Qty, 0);
      setUnitDataArr([]);
    } else if (
      e.key === "Delete" ||
      e.keyCode === 46 ||
      e.key === "Backspace"
    ) {
      if (sDetail.BarCode == "" || sDetail.CardId) {
        setDetail((obj) => ({
          ...obj,
          ItemCode: "",
          ItemName: "",
          Unit: "",
          PackQty: 0,
          LoadQty: 0,
          LoadingQty: 0,
          BalanceQty: 0,
          SuppRefNo1: 0,
        }));
        fBaseQty(sDetail.Qty, 0);
        setUnitDataArr([]);
      }
    }
  };

  const fOnChangeInput = (e) => {
    setDetail((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
    //IN MOBILE Backspace KEY NOT DETECTED TO CALL API WE USE BLUR
    if (
      e.target.value.length < sDetail.BarCode.toString().length &&
      vMediaQuery &&
      e.target.name === "BarCode"
    ) {
      var eObj = {
        key: "Backspace",
      };
      if (e.target.value !== "" && vMediaQuery) {
        fOnKeyUp(eObj);
      }
    }
  };

  const fOnChangeInputQty = (e) => {
    setDetail((obj) => ({
      ...obj,
      [e.target.name]: Number(e.target.value),
    }));
    fBaseQty(e.target.value, sDetail.PackQty);
  };
  const fQtyKey = (e) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      if (sDetail.Qty !== "") {
        fSave();
      }
    }
  };

  const fUnitSelect = useCallback(
    (e) => {
      let vUnit = sUnitData.find((obj) => {
        return obj.Unit == e.target.value;
      });
      fBaseQty(sDetail.Qty, vUnit.PackQty);
      setDetail((obj) => ({
        ...obj,
        Unit: vUnit.Unit,
        PackQty: vUnit.PackQty,
      }));
    },
    [sDetail, sUnitData]
  );

  const setValidation = () => {
    setErrorMsg(vErrorInit);

    let iRes = true;
    if (
      vRdxSubHead?.CurrentTripID == "" ||
      vRdxSubHead?.CurrentTripID == 0 ||
      vRdxSubHead?.CurrentTripID == null ||
      vRdxSubHead?.CurrentTripID == undefined
    ) {
      fAlertToast("FAILED", "TripID is Empty");

      iRes = false;
    }
    if (sDetail.SrNo === "") {
      setErrorMsg((obj) => ({ ...obj, SrNo: "SrNo is Empty" }));
      iRes = false;
    }
    if (sDetail.BarCode === "") {
      setErrorMsg((obj) => ({ ...obj, BarCode: "BarCode is Empty" }));
      iRes = false;
    }

    if (sDetail.DropID === "" && WMS_PICKING_DROP_ID_Flag()) {
      // if (sDetail.DropID === "") {
      setErrorMsg((obj) => ({ ...obj, DropID: "DropID is Empty" }));
      iRes = false;
    }
    if (sDetail.Qty === "") {
      setErrorMsg((obj) => ({ ...obj, Qty: "Qty is Empty" }));
      iRes = false;
    } else if (Number(sDetail.Qty) <= 0) {
      setErrorMsg((obj) => ({ ...obj, Qty: "Qty is Zero" }));
      iRes = false;
    }
    if (sDetail.ItemCode === "") {
      setErrorMsg((obj) => ({ ...obj, ItemCode: "ItemCode is Empty" }));
      iRes = false;
    }
    if (sDetail.ItemName === "") {
      setErrorMsg((obj) => ({ ...obj, ItemName: "ItemName is Empty" }));
      iRes = false;
    }
    if (sDetail.Unit === "") {
      setErrorMsg((obj) => ({ ...obj, Unit: "Unit is Empty" }));
      iRes = false;
    }
    if (sDetail.BaseQty === "") {
      setErrorMsg((obj) => ({ ...obj, BaseQty: "BaseQty is Empty" }));
      iRes = false;
    }
    if (sDetail.LoadQty === "") {
      setErrorMsg((obj) => ({ ...obj, LoadQty: "LoadQty is Empty" }));
      iRes = false;
    }
    if (sDetail.LoadingQty === "") {
      setErrorMsg((obj) => ({ ...obj, LoadingQty: "LoadingQty is Empty" }));
      iRes = false;
    }
    if (sDetail.BalanceQty === "") {
      setErrorMsg((obj) => ({ ...obj, BalanceQty: "BalanceQty is Empty" }));
      iRes = false;
    }
    return iRes;
  };
  let timeout = null;
  const fSave = async (e) => {
    fClearErrorMsg();
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (setValidation()) {
        await GetSaveItems();
      }
    }, 800);
  };

  const fDelete = (e) => {
    confirmAlert({
      title: "Delete",
      message: "Are you sure you want to Delete?",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: async () => {
            fClearErrorMsg();
            await GetDeleteItems();
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => document.getElementsByName("BarCode")[0]?.focus(),
        },
      ],
    });
  };

  const fClearErrorMsg = (e) => {
    setErrorMsg(vErrorInit);
  };

  const fNew = async (e) => {
    // let vDropID = sDetail.DropID;
    fClearErrorMsg();
    setUnitDataArr([]);
    setDetail(vDetailObjInit);
    await GetItems();
    // setDetail((obj) => ({
    //   ...obj,
    //   DropID: vDropID,
    // }));
    document.getElementsByName("BarCode")[0]?.focus();
  };

  const fPost = (e) => {
    fClearErrorMsg();
    GetPost();
    document.getElementsByName("BarCode")[0]?.focus();
  };

  const fVariance = (e) => {
    GetVariance("Y");
    fOpenVarianceModel();
  };
  const fDetail = (e) => {
    fOpenDetailViewModel();
  };
  const fBaseQty = (xQty, xPackQty) => {
    let vBaseQty = fcovertToNumber(xPackQty) * fcovertToNumber(xQty);
    setDetail((obj) => ({
      ...obj,
      BaseQty: vBaseQty,
    }));
  };

  //API LOADING_ITEMSEARCH_GETROW
  const GetCartBarcodeDetail = async (xSrno, xBarcode, xeditRow) => {
    const CartBarcodeDetailObj = {
      VocTyp: vRdxDetail.VocTyp,
      VocNo: vRdxDetail.VocNo,
      Version: vRdxSubHead.vocType,
      RowId: xSrno,
      Barcode: xBarcode,
    };
    const CartBarcodeDetail = await EasyLoadingBarcode_GETROW(
      CartBarcodeDetailObj
    );
    if (CartBarcodeDetail?.status === 200) {
      if (CartBarcodeDetail?.data?.ResultSet.length > 0) {
        let vBalanceQty =
          fcovertToNumber(CartBarcodeDetail?.data?.ResultSet[0].LoadQty) -
          fcovertToNumber(CartBarcodeDetail?.data?.ResultSet[0].LoadingQty);
        setDetail((obj) => ({
          ...obj,
          ItemCode: CartBarcodeDetail?.data?.ResultSet[0].ItemCode,
          ItemName: CartBarcodeDetail?.data?.ResultSet[0].ItemName,
          LoadQty: CartBarcodeDetail?.data?.ResultSet[0].LoadQty,
          LoadingQty: CartBarcodeDetail?.data?.ResultSet[0].LoadingQty,
          SuppRefNo1: CartBarcodeDetail?.data?.ResultSet[0]?.SuppRefNo1,
          BalanceQty: vBalanceQty,
        }));
        if (
          CartBarcodeDetail?.data?.ResultSet[0].ItmCd !== "" &&
          xeditRow == false
        ) {
          let itemCdInfo = await GetUnitDetail(
            CartBarcodeDetail?.data?.ResultSet[0].ItemCode
          );
          if (itemCdInfo.length > 0) {
            var vUnit = itemCdInfo.find((obj) => {
              return obj.Unit == CartBarcodeDetail?.data?.ResultSet[0].Unit;
            });
            if (!!vUnit) {
              fBaseQty(sDetail.Qty, vUnit.PackQty);
              setDetail((obj) => ({
                ...obj,
                Unit: vUnit.Unit,
                PackQty: vUnit.PackQty,
              }));
            } else {
              setDetail((obj) => ({
                ...obj,
                Unit: itemCdInfo[0].Unit,
                PackQty: itemCdInfo[0].PackQty,
              }));
              fBaseQty(sDetail.Qty, itemCdInfo[0].PackQty);
              fAlertToast("FAILED", "UnitID and Card UnitID Not Matched");
            }
          }
        }
        // document.getElementById("Qty")?.focus();
        document.getElementsByName("DropID")[0]?.focus();
      } else {
        setDetail((obj) => ({
          ...obj,
          ItemCode: "",
          SrNo: 0,
          ItemName: "",
          // BarCode: "",
          Unit: "",
          PackQty: "",
          LoadQty: "",
          LoadingQty: "",
          BalanceQty: "",
          SuppRefNo1: 0,
        }));
        setUnitDataArr([]);
        fBaseQty(sDetail.Qty, 0);
        fAlertToast("WARNING", "Wrong Barcode");
      }
    } else {
      setUnitDataArr([]);
    }
  };

  const GetUnitDetail = async (xItemCode) => {
    const UnitInfo = await fExecuteAPI(
      "ITEM_UNIT_INSTANTPICKING_GETROW",
      xItemCode
    );
    if (UnitInfo.Type == "SUCCESS") {
      if (UnitInfo.ResultSet.length > 0) {
        setUnitDataArr(UnitInfo.ResultSet);
        return UnitInfo.ResultSet;
      }
    } else if (UnitInfo.Type == "FAILED") {
      setUnitDataArr([]);
      fAlertToast("FAILED", UnitInfo.Message);
      return [];
    }
  };

  //API LOADING_ITEMLIST_GETROW
  const GetItems = async () => {
    let { VocTyp, VocNo } = RoEasyLoading();
    let { vocType } = RoEasyLoadingSubHead();
    let vItemsObj = {
      VocTyp: VocTyp,
      VocNo: VocNo,
      SrNo: vocType,
    };
    const vItems = await EasyLoading_GETROW(vItemsObj);
    if (vItems?.status === 200) {
      let GridID = vItems?.data?.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setGridRow(GridID);
    }
  };

  //API LOADING_ITEMDELETE_GETROW
  const GetDeleteItems = async () => {
    let { VocTyp, VocNo } = RoEasyLoading();
    let { vocType } = RoEasyLoadingSubHead();
    let vDeleteItemsObj = {
      VocTyp: VocTyp,
      VocNo: VocNo,
      SrNo: vocType,
      RowId: sDetail.SrNo,
    };
    const vDeleteItems = await EasyLoadingDelete_GETROW(vDeleteItemsObj);
    if (vDeleteItems?.status === 200) {
      fAlertToast("SUCCESS", "Successfully Deleted");
      fNew();
      document.getElementsByName("BarCode")[0]?.focus();
      return vDeleteItems;
    }
  };
  //API LOADING_VARIANCE_LDList_GETROW
  const GetVariance = async (variance = "Y") => {
    let { VocTyp, VocNo } = RoEasyLoading();
    let vVarianceObj = {
      VocTyp: VocTyp,
      VocNo: VocNo,
      Variance: variance,
    };
    const vVariance = await EasyLoadingVariance_GETROW(vVarianceObj);
    if (vVariance?.status === 200) {
      let GridID = vVariance?.data?.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setGridVarienceRow(GridID);
    }
  };
  //API LOADING_ITEMPOST_GETROW
  const GetPost = async () => {
    let { VocTyp, VocNo } = RoEasyLoading();
    let { vocType } = RoEasyLoadingSubHead();
    let vPostDispatchObj = {
      VocTyp: VocTyp,
      VocNo: VocNo,
      Version: vocType,
    };
    const vPostDispatch = await EasyLoadingPost_GETROW(vPostDispatchObj);
    if (vPostDispatch?.status === 200) {
      // setsInstantPickingDetail((obj) => ({ ...obj, Status: "Completed" }));
      dispatch(EasyLoadingHead_Status_Set({ Status: "Completed" }));
      fAlertToast("SUCCESS", "Successfully posted");
      fNew();
    }
  };

  //API LOADING_ITEMSAVE_GETROW
  const GetSaveItems = async () => {
    let vSaveItemsObj = {
      VocTyp: vRdxDetail.VocTyp,
      VocNo: vRdxDetail.VocNo,
      Version: vRdxSubHead.vocType,
      RowId: sDetail.SrNo,
      ItmCd: sDetail.ItemCode,
      Qty: sDetail.Qty,
      Drop_ID: sDetail.DropID,
      Unit: sDetail.Unit,
      BaseQty: sDetail.BaseQty,
      UserCd: vRdxuserInfo.UserID,
      TruckId: vRdxSubHead.TruckId,
      DriverID: vRdxSubHead.DriverID,
      DocStatus: vRdxSubHead.DocStatus,
      TripId: vRdxSubHead?.CurrentTripID,
    };

    const vSaveItems = await EasyLoadingUpdate_GETROW(vSaveItemsObj);
    if (vSaveItems?.status === 200) {
      if (vSaveItems?.data?.ResultSet.length > 0) {
        if (vSaveItems?.data?.ResultSet[0]?.isVariComp == "Y") {
          fAlertToast("SUCCESS", "Loading Completed");
          navigate("/EasyLoading");
        }
      } else {
        fAlertToast("SUCCESS", "Successfully Saved");
        fNew();
      }

      // return vSaveItems?.data?.ResultSet;
    }
  };

  const fGridRowData = async (e) => {
    setDetail((obj) => ({
      ...obj,
      SrNo: e.row.RowId,
      ItemCode: e.row.ItmCd,
      ItemName: e.row.ItmName,
      BarCode: e.row.Barcode,
      // CardId: e.row.G_CardID,
      Qty: e.row.Qty,
      BaseQty: e.row.BaseQty,
      // IndexRowID: e.row.G_NDX_ROWID,
      // RefDocTyp: e.row.G_RefDocTyp,
      // RefDocNo: e.row.G_RefDocNo,
      SuppRefNo1: e.row.SuppRefno1,
      DropID: e.row.Drop_ID,
    }));
    //to load loadqty,loadingty ,balanceQty
    GetCartBarcodeDetail(e.row.RowId, e.row.Barcode, true);
    let itemCdInfo = await GetUnitDetail(e.row.ItmCd);
    if (itemCdInfo.length > 0) {
      let currObj = itemCdInfo.find((obj) => {
        return obj.Unit == e.row.unit;
      });
      fBaseQty(e.row.Qty, currObj.PackQty);
      setDetail((obj) => ({
        ...obj,
        Unit: currObj.Unit,
        PackQty: currObj.PackQty,
      }));
    }
    fCloseDetailViewModel();
  };
  // const [sVarianceColumns, setVarianceColumns] = useState([]);
  // const [scolumns, setcolumns] = useState([]);

  const onLoad = async () => {
    // GetGitterColumns(setcolumns, "LOADING_DETAIL", columns);
    // GetGitterColumns(setVarianceColumns, "LOADING_VARIANCE", VarianceColumns);

    let iAttributeResp = await GetAttributes(setVersionData, setTruck);
    let iTruck = iAttributeResp?.Truck;
    // if (iTruck.length > 0 && vRdxSubHead?.vocType == "" ) {
    //   dispatch(
    //     EasyLoadingSubHeader_Truck_Set({
    //       TruckId: iTruck[0].TruckId,
    //       TruckName: iTruck[0].TruckName,
    //       DriverID: iTruck[0].DriverID,
    //       DriverName: iTruck[0].DriverName,
    //       TruckCBM: iTruck[0].CBM,
    //     })
    //   );
    // }
    let iVersion = iAttributeResp?.LoadVersion;
    if (iVersion.length > 0) {
      GetEasyLoadingSubHead(
        vRdxSubHead?.vocType == "" ? iVersion[0]?.uid : vRdxSubHead?.vocType,
        dispatch,
        vRdxSubHead,
        fNew
      );
    }
    await GetItems();

    EasyLoadingDetailFocusOnLoad.current?.focus();
  };
  // modal start

  const [showModal, setShowModal] = useState(false);

  // modal end

  useEffect(() => {
    onLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const buttonStyle1 = {
    background: "red",
    borderRadius: "20px",
    padding: "1px 17px",
    color: "white",
    textTransform: "none",
    minWidth: "-webkit-fill-available",
  };
  const buttonStyle2 = {
    background: "green",
    borderRadius: "20px",
    padding: "1px 17px",
    color: "white",
    textTransform: "none",
    minWidth: "-webkit-fill-available",
  };
  const buttonStyle3 = {
    background: "indigo",
    borderRadius: "20px",
    padding: "1px 17px",
    color: "white",
    textTransform: "none",
    minWidth: "-webkit-fill-available",
  };
  const buttonStyle4 = {
    background: "gray",
    borderRadius: "20px",
    padding: "1px 17px",
    color: "white",
    textTransform: "none",
    minWidth: "-webkit-fill-available",
  };
  return (
    <div className="container-fluid ">
      <div className="Breadcrumbs m-0">
        <EasyLoading_Breadcrumbs />
      </div>
      <div className="Summary-container">
        <Grid container columnSpacing={{ xs: 2, sm: 2, md: 1, lg: 1 }}>
          <Grid item xs={12} sm={6} md={4.5} lg={4.5}>
            <Box
              sx={{ flexGrow: 1 }}
              //  className="xs-instant-picking-detail-label"
            >
              <Grid container spacing={1} columns={{ xs: 12, sm: 12, md: 12 }}>
                <Grid item xs={12} sm={12} md={12}>
                  <Grid
                    container
                    spacing={0.8}
                    columns={{ xs: 12, sm: 12, md: 12 }}
                  >
                    <Grid item xs={5} sm={6} md={6}>
                      <CmpTextField
                        xLabelText={"Invoice"}
                        xVariant={"outlined"}
                        xValue={vRdxDetail.VocNo}
                        xOnChange={""}
                        xReadOnly={true}
                        xType={"text"}
                        xName={"VocNo"}
                      />
                    </Grid>

                    <Grid item xs={3} sm={6} md={6}>
                      <CmpSelectBox
                        xLabelText="Version"
                        xVariant={"outlined"}
                        xValue={vRdxSubHead.vocType}
                        xOnChange={(event) => {
                          GetEasyLoadingSubHead(
                            event.target.value,
                            dispatch,
                            vRdxSubHead,
                            fNew
                          );
                        }}
                        xName={"Version"}
                        xData={sVersionData}
                        xValueMember={""}
                        xDispalyMember={""}
                        // xError={sErrorMsg.Unit === "" ? false : true}
                        // xErrorMessage={sErrorMsg.Unit}
                        xDisable={false}
                      />
                    </Grid>
                    {/* <Grid item xs={6} sm={6} md={6}>
                  <CmpDatePicker
                    xLabelText={"Date"}
                    xValue={vRdxDetail.PostDate}
                    xOnChange={(newValue) => {
                      // setLoadObj((obj) => ({ ...obj, dateFrom: newValue.$d }));
                    }}
                    xName={"PostDate"}
                    xError={false}
                    xErrorMessage={false}
                    xDisable={true}
                  />
                </Grid> */}

                    <Grid item xs={4} sm={12} md={12}>
                      <CmpTextField
                        xLabelText={"Total CBM"}
                        xVariant={"outlined"}
                        xValue={vRdxDetail?.CBM}
                        xOnChange={""}
                        xReadOnly={true}
                        xType={"text"}
                        xName={"CBM"}
                      />
                    </Grid>
                    {/* <Grid item xs={6} sm={6} md={12}>
                  <CmpTextField
                    xLabelText={"Customer"}
                    xVariant={"outlined"}
                    xValue={vRdxDetail.PartyName}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"PartyName"}
                  />
                </Grid> */}
                    {/* <Grid item xs={6} sm={6} md={12}>
                  <CmpTextField
                    xLabelText={"Status"}
                    xVariant={"outlined"}
                    xValue={vRdxSubHead.DocStatus}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"DocStatus"}
                  />
                </Grid> */}
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Grid
                    container
                    spacing={0.8}
                    columns={{ xs: 12, sm: 12, md: 12 }}
                  >
                    {/* <Grid item xs={6} sm={6} md={6}>
                  <CmpTextField
                    xLabelText={"Driver"}
                    xVariant={"outlined"}
                    xValue={vRdxSubHead.DriverID}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"DriverID"}
                  />
                </Grid> */}

                    {/* <Grid item xs={6} sm={6} md={6}>
                  <CmpTextField
                    xLabelText={"Driver Name"}
                    xVariant={"outlined"}
                    xValue={vRdxSubHead.DriverName}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"DriverName"}
                  />
                </Grid> */}
                    <Grid item xs={6} sm={6} md={6}>
                      <CmpSelectBox
                        xref={EasyLoadingDetailFocusOnLoad}
                        xLabelText="Truck"
                        xVariant={"outlined"}
                        xValue={vRdxSubHead?.TruckId}
                        xOnChange={async (event) => {
                          let vTruckObj = sTruck.find((obj) => {
                            return obj.TruckId === event.target.value;
                          });

                          let respTripId = await fTruckid_dependency(
                            vTruckObj.TruckId
                          );

                          if (vTruckObj) {
                            dispatch(
                              EasyLoadingSubHeader_Set({
                                ...vRdxSubHead,
                                TruckId: vTruckObj.TruckId,
                                TruckName: vTruckObj.TruckName,
                                DriverID: vTruckObj.DriverID,
                                DriverName: vTruckObj.DriverName,
                                TruckCBM: vTruckObj.CBM,
                                CurrentTripID: respTripId,
                              })
                            );

                            document.getElementById("BarCode")?.focus();
                          }
                        }}
                        xName={"TruckId"}
                        xId={"TruckId"}
                        xData={sTruck}
                        xValueMember={""}
                        xDispalyMember={""}
                        // xError={sErrorMsg.Unit === "" ? false : true}
                        // xErrorMessage={sErrorMsg.Unit}
                        xDisable={sGridRow.length > 0}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sm={6}
                      md={6}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {vRdxSubHead?.CurrentTripID == "" ||
                      vRdxSubHead?.CurrentTripID == 0 ||
                      vRdxSubHead?.CurrentTripID == null ||
                      vRdxSubHead?.CurrentTripID == undefined ? (
                        <CmpButton
                          xbtnName="New Trip"
                          xOnClick={async () => {
                            let respTripId = await fNewTrip_Create(
                              vRdxSubHead?.TruckId
                            );
                            dispatch(
                              EasyLoadingSubHeader_Set({
                                ...vRdxSubHead,
                                CurrentTripID: respTripId,
                              })
                            );
                          }}
                          xVariant="contained"
                          xSize="small"
                          xDisabled={vRdxDetail.Status === "Completed"}
                        />
                      ) : (
                        <CmpTextField
                          xLabelText={"TripID"}
                          xVariant={"outlined"}
                          xValue={vRdxSubHead?.CurrentTripID}
                          xOnChange={""}
                          xReadOnly={true}
                          xType={"text"}
                          xName={"CurrentTripID"}
                        />
                      )}
                    </Grid>
                    {/* <Grid item xs={6} sm={6} md={6}>
                  <CmpTextField
                    xLabelText={"Truck Name"}
                    xVariant={"outlined"}
                    xValue={vRdxSubHead?.TruckName}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"TruckName"}
                  />
                </Grid> */}
                    <Grid item xs={6} sm={6} md={6}>
                      <CmpTextField
                        xLabelText={"Total CBM"}
                        xVariant={"outlined"}
                        xValue={vRdxSubHead?.TruckCBM}
                        xOnChange={""}
                        xReadOnly={true}
                        xType={"text"}
                        xName={"TruckCBM"}
                      />
                    </Grid>
                    <Grid item xs={6} sm={6} md={6}>
                      <CmpTextField
                        xLabelText={"RefNo"}
                        xVariant={"outlined"}
                        xValue={vRdxDetail?.RefNo}
                        xOnChange={""}
                        xReadOnly={true}
                        xType={"text"}
                        xName={"RefNo"}
                      />
                    </Grid>
                    {/* <Grid item xs={6} sm={6} md={6}>
                  <CmpTextField
                    xLabelText={"Inv.CBM"}
                    xVariant={"outlined"}
                    xValue={vRdxSubHead?.LoadedCBM}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"LoadedCBM"}
                  />
                </Grid> */}
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ display: WMS_PICKING_DROP_ID_Flag() ? "" : "none" }}
                >
                  {/* <CmpTextField
                    xLabelText={"Drop ID"}
                    xVariant={"outlined"}
                    xValue={vRdxDetail.dropid}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"dropid"}
                  /> */}
                  <TextField
                    label="Drop ID"
                    fullWidth
                    multiline
                    maxRows={4}
                    value={vRdxDetail.dropid}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
            <br></br>

            <Grid
              container
              spacing={0.5}
              columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              className="mb-3 buttonstyle"
            >
              {/* <Grid item xs={6} sm={6} md={3} textAlign={"center"}>
         
            <Button size="small" style={buttonStyle1}>
              Doc.No &nbsp; {vRdxDetail?.VocNo}
            </Button>
          </Grid>

          <Grid item xs={6} sm={6} md={3} textAlign={"center"}>
            
            <Button size="small" style={buttonStyle3}>
              Load Qty &nbsp; &nbsp; {sDetail?.LoadQty}
            </Button>
          </Grid>
          <Grid item xs={6} sm={6} md={3} textAlign={"center"}>
            
            <Button size="small" style={buttonStyle4}>
              Loading Qty &nbsp; &nbsp; {sDetail?.LoadingQty}
            </Button>
          </Grid>
          <Grid item xs={6} sm={6} md={3} textAlign={"center"}>
            
            <Button size="small" style={buttonStyle2}>
              Balance Qty &nbsp; &nbsp;{sDetail?.BalanceQty}
            </Button>
          </Grid> */}

              <Grid item xs={12} sm={12} md={12} lg={4} textAlign={"center"}>
                <Button size="small" style={buttonStyle3}>
                  Balance &nbsp; &nbsp; {sDetail?.LoadQty} /{" "}
                  {sDetail?.LoadingQty} / {sDetail?.BalanceQty}
                </Button>
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={4} textAlign={"center"}>
                <Button size="small" style={buttonStyle4}>
                  Ref.No &nbsp; &nbsp; {sDetail?.SuppRefNo1}
                </Button>
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={4} textAlign={"center"}>
                <Button
                  size="small"
                  style={buttonStyle2}
                  onClick={async () => {
                    await GetVariance("N");
                    setShowModal(true);
                  }}
                >
                  Item List
                </Button>
              </Grid>
            </Grid>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={0} columns={{ xs: 24, sm: 12, md: 12 }}>
                {/* <Grid item xs={12} sm={12} md={12}>
              Detail Trans
            </Grid> */}
                <Grid item xs={24} sm={12} md={12}>
                  <Grid
                    container
                    spacing={0.8}
                    columns={{ xs: 8, sm: 12, md: 12 }}
                  >
                    <Grid item xs={4} sm={6} md={6}>
                      <CmpTextFieldEnter
                        xLabelText={"BarCode"}
                        xVariant={"outlined"}
                        xValue={sDetail.BarCode}
                        xOnChange={(event) => fOnChangeInput(event)}
                        xReadOnly={false}
                        xType={"text"}
                        xName={"BarCode"}
                        xId={"BarCode"}
                        xOnKeyUp={(e) => {
                          fOnKeyUp(e);
                        }}
                        xError={sErrorMsg.BarCode === "" ? false : true}
                        xErrorMessage={sErrorMsg.BarCode}
                        xOnEnter={(e) => {
                          fOnKeyUp(sEnterKeyObj);
                        }}
                        xSmShow={!!vMediaQuery}
                      />
                    </Grid>
                    <Grid item xs={4} sm={6} md={6}>
                      {/* <CmpTextField
                    xLabelText={"SrNo"}
                    xVariant={"outlined"}
                    xValue={sDetail.SrNo}
                    xOnChange={(event) => fOnChangeInput(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"SrNo"}
                    xError={sErrorMsg.SrNo === "" ? false : true}
                    xErrorMessage={sErrorMsg.SrNo}
                  /> */}
                      <CmpTextField
                        xLabelText={"DropID"}
                        xVariant={"outlined"}
                        xValue={sDetail.DropID}
                        xOnChange={(event) => {
                          fOnChangeInput(event);
                        }}
                        xReadOnly={false}
                        xType={"text"}
                        xName={"DropID"}
                        xError={sErrorMsg.DropID === "" ? false : true}
                        xErrorMessage={sErrorMsg.DropID}
                        xOnKeyUp={(e) => {
                          if (e.key === "Enter") {
                            document.getElementById("Qty")?.focus();
                          }
                        }}
                      />
                    </Grid>
                    {/* 
                <Grid item xs={2} sm={2} md={3}>
                  <CmpTextField
                    xLabelText={"ItemCode"}
                    xVariant={"outlined"}
                    xValue={sDetail.ItemCode}
                    xOnChange={(event) => fOnChangeInput(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"ItemCode"}
                    xError={sErrorMsg.ItemCode === "" ? false : true}
                    xErrorMessage={sErrorMsg.ItemCode}
                  />
                </Grid> */}
                    {/* <Grid
                  item
                  xs={4}
                  sm={4}
                  md={3}
                  style={{ display: WMS_PICKING_DROP_ID_Flag() ? "" : "none" }}
                >
                  <CmpTextField
                    xLabelText={"Drop Id"}
                    xVariant={"outlined"}
                    xValue={sDetail.DropID}
                    xOnChange={(event) => fOnChangeInput(event)}
                    xReadOnly={false}
                    xType={"text"}
                    xName={"DropID"}
                    xError={sErrorMsg.DropID === "" ? false : true}
                    xErrorMessage={sErrorMsg.DropID}
                  />
                </Grid> */}
                    <Grid item xs={12} sm={12} md={12}>
                      <CmpTextField
                        xLabelText={"ItemName"}
                        xVariant={"outlined"}
                        xValue={sDetail.ItemName}
                        xOnChange={(event) => fOnChangeInput(event)}
                        xReadOnly={true}
                        xType={"text"}
                        xName={"ItemName"}
                        xError={sErrorMsg.ItemName === "" ? false : true}
                        xErrorMessage={sErrorMsg.ItemName}
                      />
                    </Grid>
                    <Grid item xs={4} sm={6} md={6}>
                      <CmpTextField
                        xLabelText={"Qty"}
                        xVariant={"outlined"}
                        xValue={sDetail.Qty}
                        xOnChange={(event) => fOnChangeInputQty(event)}
                        xReadOnly={false}
                        xType={"number"}
                        xName={"Qty"}
                        xOnKeyUp={(e) => {
                          fQtyKey(e);
                        }}
                        xonFocus={(e) => {
                          if (e.target.value == 0) {
                            setDetail((obj) => ({
                              ...obj,
                              Qty: "",
                            }));
                          }
                        }}
                        xonBlur={(e) => {
                          if (e.target.value == "") {
                            setDetail((obj) => ({
                              ...obj,
                              Qty: (0).toFixed(2),
                            }));
                          }
                        }}
                        xError={sErrorMsg.Qty === "" ? false : true}
                        xErrorMessage={sErrorMsg.Qty}
                      />
                    </Grid>
                    <Grid item xs={4} sm={6} md={6}>
                      <CmpSelectBox
                        xLabelText="Unit"
                        xValue={sDetail.Unit}
                        xOnChange={(event) => fUnitSelect(event)}
                        xName={"Unit"}
                        xData={sUnitData}
                        xValueMember={""}
                        xDispalyMember={""}
                        xError={sErrorMsg.Unit === "" ? false : true}
                        xErrorMessage={sErrorMsg.Unit}
                        xDisable={false}
                      />
                    </Grid>
                    {/* <Grid item xs={3} sm={3} md={2}>
                  <CmpTextField
                    xLabelText={"BaseQty"}
                    xVariant={"outlined"}
                    xValue={sDetail.BaseQty}
                    xOnChange={(event) => fOnChangeInput(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"BaseQty"}
                    xError={sErrorMsg.BaseQty === "" ? false : true}
                    xErrorMessage={sErrorMsg.BaseQty}
                  />
                </Grid> */}
                    {/* <Grid item xs={4} sm={3} md={3}>
                  <CmpTextField
                    xLabelText={"Inv.Qty"}
                    xVariant={"outlined"}
                    xValue={sDetail.LoadQty}
                    xOnChange={(event) => fOnChangeInput(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"LoadQty"}
                    xError={sErrorMsg.LoadQty === "" ? false : true}
                    xErrorMessage={sErrorMsg.LoadQty}
                  />
                </Grid> */}
                    {/* <Grid item xs={4} sm={3} md={3}>
                  <CmpTextField
                    xLabelText={"LoadingQty"}
                    xVariant={"outlined"}
                    xValue={sDetail.LoadingQty}
                    xOnChange={(event) => fOnChangeInput(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"LoadingQty"}
                    xError={sErrorMsg.LoadingQty === "" ? false : true}
                    xErrorMessage={sErrorMsg.LoadingQty}
                  />
                </Grid> */}
                    {/* <Grid item xs={4} sm={3} md={3}>
                  <CmpTextField
                    xLabelText={"BalanceQty"}
                    xVariant={"outlined"}
                    xValue={sDetail.BalanceQty}
                    xOnChange={(event) => fOnChangeInput(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"BalanceQty"}
                    xError={sErrorMsg.BalanceQty === "" ? false : true}
                    xErrorMessage={sErrorMsg.BalanceQty}
                  />
                </Grid> */}
                    {/* <Grid item xs={4} sm={3} md={3}>
                  <CmpTextField
                    xLabelText={"CBM"}
                    xVariant={"outlined"}
                    xValue={""}
                    xOnChange={(event) => fOnChangeInput(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"BaseQty"}
                    xError={sErrorMsg.BaseQty === "" ? false : true}
                    xErrorMessage={sErrorMsg.BaseQty}
                  />
                </Grid> */}
                  </Grid>
                </Grid>
              </Grid>
            </Box>
            <br></br>
            <Box sx={{ flexGrow: 1 }} className="easy-loading-btn">
              <Grid
                container
                spacing={1}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                className="text-center"
              >
                <Grid item xs={4} sm={4} md={4} lg={3}>
                  <CmpButton
                    xbtnName="New"
                    xOnClick={fNew}
                    xVariant="contained"
                    xSize="small"
                  />
                </Grid>
                <Grid item xs={4} sm={4} md={4} lg={3}>
                  <CmpButton
                    xbtnName="Save"
                    xOnClick={fSave}
                    xVariant="contained"
                    xSize="small"
                    xDisabled={vRdxDetail.Status === "Completed"}
                  />
                </Grid>
                <Grid item xs={4} sm={4} md={4} lg={3}>
                  <CmpButton
                    xbtnName="Delete"
                    xOnClick={fDelete}
                    xVariant="contained"
                    xSize="small"
                    xDisabled={vRdxDetail.Status === "Completed"}
                  />
                </Grid>
                <Grid
                  item
                  xs={4}
                  sm={4}
                  md={4}
                  lg={3}
                  className="btn-instant-picking-Detail"
                >
                  <CmpButton
                    xbtnName="Detail"
                    xOnClick={fDetail}
                    xVariant="contained"
                    xSize="small"
                  />
                </Grid>
                <Grid item xs={4} sm={4} md={4} lg={3}>
                  <CmpButton
                    xbtnName="Post"
                    xOnClick={fPost}
                    xVariant="contained"
                    xSize="small"
                    xDisabled={vRdxDetail.Status === "Completed"}
                  />
                </Grid>
                <Grid item xs={4} sm={4} md={4} lg={3}>
                  <CmpButton
                    xbtnName="Variance"
                    xOnClick={fVariance}
                    xVariant="contained"
                    xSize="small"
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>

          <Grid item xs={7.5} sm={6} md={7.5} lg={7.5}>
            <div
              style={{
                height: vMediaQuery ? "65vh" : "72vh",
                overflowY: "auto",
                paddingTop: "8px",
              }}
              className="xs-instant-picking-detail-grid"
            >
              <Grid container spacing={1} px={1}>
                {Array.isArray(sGridRow) &&
                  sGridRow?.length > 0 &&
                  sGridRow?.map((item, index) => (
                    <Grid item xs={12} sm={12} md={6} key={index}>
                      <DetailCardComp
                        data={item}
                        onClick={(item) => {
                          fGridRowData({ row: item });
                        }}
                        headerLabel={item.ItmName}
                        content={
                          <Grid container spacing={1}>
                            <DetailInputDisplay
                              label="Barcode"
                              value={item.Barcode}
                            />
                            <DetailInputDisplay
                              label="Ref.No"
                              value={item.SuppRefno1}
                            />
                            <DetailInputDisplay label="Qty" value={item.Qty} />
                            <DetailInputDisplay
                              label="Unit.Code"
                              value={item.UnitName}
                            />
                          </Grid>
                        }
                      />
                    </Grid>
                  ))}
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>

      <Modal
        open={sOpenDetailViewModel}
        onClose={fCloseDetailViewModel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance detail">
          <div>
            <GCTitleSticky title={"Detail"} onClose={fCloseDetailViewModel} />

            {/* <Box
                style={{ height: vMediaQuery ? "70vh" : "40vh", width: "100%" }}
                className="bintransfer-out-grid"
              >
                <DataGrid
                  rowHeight={30}
                  headerHeight={40}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0
                      ? "mui-even-row"
                      : "mui-odd-row"
                  }
                  sx={{
                    border: 1,
                    borderColor: "primary.light",
                  }}
                  rows={sGridRow}
                  columns={scolumns}
                  // pageSize={5}
                  // rowsPerPageOptions={[5]}
                  hideFooter={sGridRow.length < 100}
                  onRowClick={fGridRowData}
                  components={{
                    Toolbar: GridToolbar,
                  }}
                />
              </Box> */}
            <Grid container spacing={1} p={1}>
              {Array.isArray(sGridRow) &&
                sGridRow?.length > 0 &&
                sGridRow?.map((item, index) => (
                  <Grid item xs={12} sm={12} md={6} key={index}>
                    <DetailCardComp
                      data={item}
                      onClick={(item) => {
                        fGridRowData({ row: item });
                      }}
                      headerLabel={item.ItmName}
                      content={
                        <Grid container spacing={1}>
                          <DetailInputDisplay
                            label="Barcode"
                            value={item.Barcode}
                          />
                          <DetailInputDisplay
                            label="Ref.No"
                            value={item.SuppRefno1}
                          />
                          <DetailInputDisplay label="Qty" value={item.Qty} />
                          <DetailInputDisplay
                            label="Unit.Code"
                            value={item.UnitName}
                          />
                        </Grid>
                      }
                    />
                  </Grid>
                ))}
            </Grid>
          </div>
        </Box>
      </Modal>

      <Modal
        open={sOpenPostVarianceModel}
        onClose={fCloseVarianceModel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <div>
            <GCTitleSticky title={"Variance"} onClose={fCloseVarianceModel} />
            <Grid container spacing={1} p={1}>
              {Array.isArray(sGridVarienceRow) &&
                sGridVarienceRow?.length > 0 &&
                sGridVarienceRow?.map((item, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <DetailCardComp
                      data={item}
                      onClick={() => {}}
                      headerLabel={item.ItemName}
                      content={
                        <Grid container spacing={1}>
                          <DetailInputDisplay
                            label="Barcode"
                            value={item.barcode}
                          />
                          <DetailInputDisplay
                            label="Ref.No"
                            value={item.supprefno1}
                          />
                          <DetailInputDisplay
                            label="LoadedQty"
                            value={item.LoadedQty}
                          />
                          <DetailInputDisplay
                            label="InvQty"
                            value={item.InvQty}
                          />
                          <DetailInputDisplay
                            label="Difference"
                            value={item.Difference}
                          />
                        </Grid>
                      }
                    />
                  </Grid>
                ))}
            </Grid>
          </div>
        </Box>
      </Modal>

      <EasyLoadingModal
        xOpen={showModal}
        fCloseModal={() => {
          setShowModal(false);
          setGridVarienceRow([]);
        }}
        xTitle="List Item Modal"
        component={
          <>
            <Grid container spacing={1} p={1}>
              {Array.isArray(sGridVarienceRow) &&
                sGridVarienceRow?.length > 0 &&
                sGridVarienceRow?.map((item, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <DetailCardComp
                      data={item}
                      onClick={() => {}}
                      headerLabel={item.ItemName}
                      content={
                        <Grid container spacing={1}>
                          <DetailInputDisplay
                            label="Barcode"
                            value={item.barcode}
                          />
                          <DetailInputDisplay
                            label="Ref.No"
                            value={item.supprefno1}
                          />
                          <DetailInputDisplay
                            label="LoadedQty"
                            value={item.LoadedQty}
                          />
                          <DetailInputDisplay
                            label="InvQty"
                            value={item.InvQty}
                          />
                          <DetailInputDisplay
                            label="Difference"
                            value={item.Difference}
                          />
                        </Grid>
                      }
                    />
                  </Grid>
                ))}
            </Grid>
          </>
        }
      />
    </div>
  );
}
